import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  byId: {},
  currentPostUid: null,
  params: {},
  signed_url: {},
  posts: [],
  error: {},
  actionsloading: false,
});

export function postReducer(state = initialState, action) {
  // console.log('in post reduecer....', action)

  switch (action.type) {
    case actionTypes.CREATE:
    case actionTypes.UPDATE:
    case actionTypes.FETCH_COLLECTION:
    case actionTypes.GET_POSTS_SIGNED_URL:
    case actionTypes.FETCH_POSTS_BY_SIGNED_URL:
      return {
        ...state,
        byId: {},
        actionsloading: true,
      };
    case actionTypes.DELETE:
      return {
        ...state,
        actionsloading: true,
      };
    case actionTypes.FETCH_ONE_SUCCESS:
    case actionTypes.FETCH_COLLECTION_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        params: action.payload.params || {},
        actionsloading: false,
      };
    case actionTypes.FETCH_POSTS_BY_SIGNED_URL_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        params: action.payload.params || {},
        actionsloading: false,
      };
    case actionTypes.GET_POSTS_SIGNED_URL_SUCCESS:      
      return {
        ...state,
        signed_url: action.payload.url || {},
        actionsloading: false,
      };
    case actionTypes.CREATE_FAILED:
      return {
        ...state,
        error: action.payload,
        actionsloading: false,
      };
    case actionTypes.UPDATE_SUCCESS:
    case actionTypes.CREATE_SUCCESS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.postUid]: action.payload,
        },
        currentPostUid: action.payload.postUid,
        actionsloading: false,
      };
    // return state.setIn(['byId', action.payload.postUid], action.payload);
    case actionTypes.DELETE_SUCCESS:
      Object.keys(state.byId).forEach(function (key, index) {
        console.log(key);
        if (state.byId[key].postUid === action.payload.id) {
          delete state.byId[key];
        }
      });
      return {
        ...state,
        byId: state.byId,
        actionsloading: false,
      };
    default:
      return state;
  }
}
